import React from 'react'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { CommentInfo } from '@/domains/hooks/useDelivery'
import { UserInfo } from '@/domains/hooks/useUser'
import { Avatar, Col, Row, Space } from 'antd'  
import { globalStore } from '@/common'
import { formatTimeDifference } from '@/utils/S'
import { Comment } from '@/common/model'

function resolveCommentAvatar(
  fromUserId?: string,
  fromUser?: UserInfo | null,
): string {
  if (fromUser?.userAvatar) {
    return fromUser.userAvatar
  }
  if (!fromUserId) {
    return ''
  }
  return globalStore.userMap.get(String(fromUserId))?.userAvatar ?? ''
}

function resolveCommentUserName(
  fromUser?: UserInfo | null,
  fromUserId?: string,
): string {
  if (fromUser?.userName) {
    return fromUser.userName
  }
  if (!fromUserId) {
    return '未知'
  }
  return globalStore.userMap.get(String(fromUserId))?.userName ?? '未知'
}

type Props = {
  oldDataSource: CommentInfo[]
  newDataSource: Comment[]
}

function CommentList(props: Props): JSX.Element {
  const { oldDataSource, newDataSource } = props 
 
  
  if( !(!oldDataSource && newDataSource.length > 0 || !newDataSource && oldDataSource.length > 0)){
    return <div style={{ marginBottom: 20 }}>暂无评论</div>
  }  
  
  return (

    oldDataSource ?  
    <Space  className="comment-list" size={10} direction='vertical'> 
      {oldDataSource.map((item) => (
        <Row key={item.commentId} className='comment-list-item'>
          <Col span={3}>
                  <Avatar
                    size={28}
                    src={resolveCommentAvatar(item.fromUserId, item.fromUser)}
                  />
          </Col>
          <Col span={21}>
                <Row>
                    <Col span={24} className='user-name'>
                      <span className='user-name'>
                        {resolveCommentUserName(item.fromUser, item.fromUserId)}
                      </span>
                      <span className='time-desc' > { formatTimeDifference(item.createTime)}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        {item.content.split('\n').map(
                          (text: string, index: number): JSX.Element => (
                            <p
                              key={index}
                              style={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-all'
                              }}
                            >
                              {text}
                            </p>
                          )
                        )}
                    </Col>
                </Row>
          </Col>
        </Row>
      ))}
    </Space>

    :

    <Space  className="comment-list" size={10} direction='vertical'> 
      {newDataSource.map((item) => (
        <Row key={item.id} className='comment-list-item'>
          <Col span={3}>
                  <Avatar
                    size={28}
                    src={resolveCommentAvatar(String(item.fromUserId), null)}
                  />
          </Col>
          <Col span={21}>
                <Row>
                    <Col span={24} className='user-name'>
                      <span className='user-name' > {item.fromUserName} </span>
                      <span className='time-desc' > { formatTimeDifference(item.createTime)}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        {item.content.split('\n').map(
                          (text: string, index: number): JSX.Element => (
                            <p
                              key={index}
                              style={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-all'
                              }}
                            >
                              {text}
                            </p>
                          )
                        )}
                    </Col>
                </Row>
          </Col>
        </Row>
      ))}
    </Space>
  )
}

export default observer(CommentList)
